import * as React from 'react'
import {ChangeEventHandler, ReactNode} from 'react'
import './Checkbox.scss'
import joinClassNames from '../../../helpers/joinClassNames'

type Props = {
    name: string
    label?: string
    isRequired?: boolean
    children?: ReactNode
    id?: string
    value?: boolean
    wrapperClassName?: string
    onChange?: ChangeEventHandler<HTMLInputElement>
}

const Checkbox = ({label, name, isRequired, children, id, value, wrapperClassName, onChange}: Props) => {
    return (
        <div className={joinClassNames('field', wrapperClassName)}>
            <div className="control">
                <label
                    htmlFor={id || name}
                    className="checkbox"
                    style={{display: 'block', textAlign: 'justify', lineHeight: '1rem'}}
                >
                    <input
                        id={id || name}
                        name={name}
                        aria-label={name}
                        className="checkbox is-small is-dark"
                        type="checkbox"
                        required={isRequired}
                        value={value === undefined ? undefined : value.toString()}
                        onChange={onChange}
                    />
                    {label || children}
                    {isRequired && <span style={{lineHeight: '1rem', fontSize: '0.75rem'}}> *</span>}
                </label>
            </div>
        </div>
    )
}

export default Checkbox
